import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Menu } from 'antd';
import PropTypes from 'prop-types';
import { SettingOutlined } from '@ant-design/icons';
import UserActions from '@Actions/userActions';
import EntityTab from './EntityTab';
import './style.scss';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';

const DocumentConfiguration = ({
  user, location, history, tab,
}) => {
  const [currentDocTab, setCurrentDocTab] = useState('/po');

  useEffect(() => {
    if (new URLSearchParams(location.search).get('docTab')) {
      setCurrentDocTab(new URLSearchParams(location.search).get('docTab'));
    }
  }, []);

  const getItem = (label, key, icon, children, type) => ({
    label,
    key,
    icon,
    children,
    type,
  });

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  const items = [
    getItem('Stock Transfer', '/st'),
    getItem('Delivery Challan', '/dc'),
    getItem('Material Request', '/pr'),
    getItem('Purchase Indent', '/pi'),
    getItem('Purchase Order', '/po'),
    getItem('Goods Receiving Note', '/grn'),
    getItem('Account Payable Invoice', '/api'),
    getItem('Bill of Material', '/bom'),
    getItem('Manufacturing Order', '/mo'),
    getItem('Manual Production Entry', '/mpe'),
    getItem('Job Work', '/jw'),
    getItem(documentUINames.estimateUIName, '/se'),
    getItem(documentUINames.salesOrderUIName, '/so'),
    getItem('Annual Maintenance Contract', '/amc'),
    getItem('Packing Slip', '/ps'),
    getItem('Invoice', '/inv'),
    getItem('Consumption Order', '/co'),
    getItem('Credit Note', '/cn'),
    getItem('Return Slip', '/rs'),
    getItem('Quality Checks', '/qc'),
    getItem('Debit Note', '/dn'),

  ];

  return (
    <div className="document-configuration__wrapper-outer">
      <div className="document-configuration__menu">
        <Menu
          onClick={(event) => {
            history.push(`?tab=${tab}&docTab=${event.key}`);
            setCurrentDocTab(event.key);
          }}
          style={{
            width: 226,
            overflowY: 'auto',
            maxHeight: 'calc(100dvh - 140px)',
            overflowX: 'hidden',
          }}
          selectedKeys={[currentDocTab]}
          defaultSelectedKeys={['1']}
          mode="inline"
          items={items}
        />
      </div>

      <div className="document-configuration-menu-items">
        {
          currentDocTab === '/st' && <EntityTab entityName="STOCK_TRANSFER" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/dc' && <EntityTab entityName="DELIVERY_CHALLAN" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/pr' && <EntityTab entityName="PURCHASE_REQUEST" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/pi' && <EntityTab entityName="PURCHASE_INDENT" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/po' && <EntityTab entityName="PURCHASE_ORDER" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/grn' && <EntityTab entityName="GOOD_RECEIVING_NOTES" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/api' && <EntityTab entityName="ACCOUNT_PAYABLE_INVOICE" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/dn' && <EntityTab entityName="DEBIT_NOTE" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/bom' && <EntityTab entityName="BILL_OF_MATERIAL" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/mo' && <EntityTab entityName="MANUFACTURING_ORDER" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/mpe' && <EntityTab entityName="MANUAL_PRODUCTION_ENTRY" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/jw' && <EntityTab entityName="JOB_WORK" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/se' && <EntityTab entityName="SALES_ESTIMATE" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/so' && <EntityTab entityName="SALES_ORDER" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/amc' && <EntityTab entityName="ANNUAL_MAINTENANCE_CONTRACT" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/ps' && <EntityTab entityName="PACKING_SLIP" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/inv' && <EntityTab entityName="INVOICE" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/co' && <EntityTab entityName="CONSUMPTION_ORDER" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/cn' && <EntityTab entityName="CREDIT_NOTE" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/rs' && <EntityTab entityName="RETURN_SLIP" tab={tab} docTab={currentDocTab} />
        }
        {
          currentDocTab === '/qc' && <EntityTab entityName="QUALITY_CHECKS" tab={tab} docTab={currentDocTab} />
        }
      </div>
    </div>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
});

DocumentConfiguration.propTypes = {
  user: PropTypes.object,
  location: PropTypes.func,
  getUserProfile: PropTypes.func,
  history: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DocumentConfiguration));
